<template>
  <Modal @close="cancelStoreModal()">
    <div class="p-modal__content__header">{{ $t('labels.selectTargetStores') }}</div>

    <div class="p-modal__content__body">
      <FilterItem
        :list="allStores"
        :list-type="'store'"
        value-key="uuid"
        :store-name="storeName"
        :head-text="$t('labels.selectAll')"
        filter-type="stores"
      />
    </div>

    <div class="p-modal__content__footer">
      <div class="store-count-wap">{{ $t('labels.targetStoreCount') }}<span class="store-count">{{ storeTotalCount }}</span>{{ $t('labels.storeCountUnit') }}</div>
      <div class="c-button c-button--right">
        <button class="c-button__item c-button__item--outline-cancel" @click.prevent="cancelStoreModal()">{{ $t('labels.backSelectCondition') }}</button>
        <button class="c-button__item c-button__item--primary" @click.prevent="confirmStoreModal()">{{ $t('labels.submitFilterCond') }}</button>
      </div>
    </div>
  </Modal>
</template>

<script>
import { mapState } from 'vuex'
import Modal from './Modal.vue'
import FilterItem from './FilterItem.vue'

export default {
  name: 'StoreModal',
  components: {
    Modal,
    FilterItem,
  },
  props: {
    storeName: {
      type: String,
      required: true
    },
    storeTotalCountKey: {
      type: String,
      default: 'storeTotalCount'
    }
  },
  emits: ['back-filter-modal', 'close-store-modal'],
  computed: {
    ...mapState({
      gmbStores:  state => state.companiesGmbSearchStores.data,
      formValues(state) {
        return state[this.storeName].formValues
      },
    }),
    storeTotalCount() {
      return this.$store.getters[this.storeName + '/' + this.storeTotalCountKey]
    },
    allStores() {
      return this.gmbStores.map(v => {
        return {
          uuid: v.attributes.uuid,
          name: v.attributes.name
        }
      })
    },
    allStoreUuids() {
      return this.allStores.map(store => store.uuid)
    }
  },
  created() {
    if (this.formValues.stores.length === 0) {
      this.setFormValues({ stores: this.allStoreUuids })
    }
  },
  methods: {
    setFormValues(payload) {
      this.$store.commit(`${this.storeName}/setFormValues`, payload)
    },
    cancelStoreModal() {
      this.setFormValues({ stores: [] })
      this.$emit('back-filter-modal')
    },
    confirmStoreModal() {
      this.$emit('close-store-modal', this.formValues.stores)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../stylesheets/biz_spa/foundation/_var.scss';

.p-modal {
  &__content {
    &__footer {
      padding: 12px 32px;
      border-top: 1px solid $color-base-c;
    }
  }
}
.store-count-wap {
  position: absolute;
  bottom: 5px;
  right: 270px;
}

.store-count {
  margin: 0 5px;
  font-size: 30px;
  font-weight: 700;
  color: $color-accent-primary;
}

</style>